const DEFAULT_SUBTYPE = 'sweepstakes'

function escapeRegExp (s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Normalizes universal-template subtype for URL segment (default: sweepstakes).
 */
export function normalizeUniversalTemplateSubtype (subtype) {
  const s = String(subtype ?? DEFAULT_SUBTYPE).trim().toLowerCase()
  if (!/^[a-z0-9-]+$/.test(s)) return DEFAULT_SUBTYPE
  return s
}

/**
 * URL prefix for universal-template slugs, e.g. sweepstakes → `/sweepstakes/`
 */
export function getUniversalTemplateSlugPrefix (subtype) {
  const seg = normalizeUniversalTemplateSubtype(subtype)
  return `/${seg}/`
}

/**
 * Editable slug suffix: segment after `{subtype}/` (supports legacy `/{venue}/{subtype}/{suffix}`).
 */
export function getUniversalTemplateSlugSuffix (slug, subtype) {
  const normalized = String(slug ?? '')
    .replace(/^\/+/, '')
    .toLowerCase()
  const seg = normalizeUniversalTemplateSubtype(subtype)
  let marker = `${seg}/`
  let idx = normalized.indexOf(marker)
  if (idx === -1 && seg !== DEFAULT_SUBTYPE) {
    marker = `${DEFAULT_SUBTYPE}/`
    idx = normalized.indexOf(marker)
  }
  if (idx === -1) return normalized
  return normalized.slice(idx + marker.length)
}

/** Allowed characters for the segment after `/{subtype}/`. */
export const UNIVERSAL_TEMPLATE_SLUG_SUFFIX_RE = /^[a-z0-9][a-z0-9-]*$/

export function isValidUniversalTemplateSlug (slug, subtype) {
  const seg = normalizeUniversalTemplateSubtype(subtype)
  return new RegExp(`^/${escapeRegExp(seg)}/[a-z0-9][a-z0-9-]*$`).test(String(slug ?? ''))
}

/**
 * Builds the full page slug for universal-template from display name.
 * Format matches validation: `/{subtype}/{suffix}` (subtype from page, default sweepstakes).
 *
 * @param {string} name
 * @param {string} [_venueId] unused; kept for call-site compatibility
 * @param {unknown} [_venues] unused; kept for call-site compatibility
 * @param {string} [subtype]
 * @returns {string} Full slug, or empty string if name is empty / invalid suffix
 */
export function buildUniversalTemplateSlugFromName (name, _venueId, _venues, subtype) {
  const trimmed = String(name ?? '').trim()
  if (!trimmed) return ''

  let suffix = trimmed
    .replace(/^\/+/, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
  suffix = suffix.replace(/^[^a-z0-9]+/, '')
  if (!suffix) return ''

  return `${getUniversalTemplateSlugPrefix(subtype)}${suffix}`
}
